import isTouchDevice from './_detectTouch';

export const CLASSES = {
  active: 'is-active',
  visible: 'is-visible',
  hidden: 'is-hidden',
  transform: 'is-transform',
  open: 'is-open',
  modalOpened: 'is-modal-opened',
  menuOpened: 'is-menu-open'
};

export const DOM = {
  body: document.querySelector('body'),
  $body: $('body'),
  html: document.querySelector('html'),
  $html: $('html'),
  window,
  $window: $(window)
};

export const GLOBAL = {
  lang: DOM.$html.hasClass('en') ? 'en' : 'ru',
  isTouch: isTouchDevice()
};

export const BREAKPOINTS = {
  desktop: 1279,
  desktopSm: 1119,
  tablet: 900,
  mobile: 767,
  mobileSm: 479
};

export const DETECT_DEVICE = {
  isDesktop() {
    return $(DOM.window).innerWidth() > BREAKPOINTS.desktop;
  },
  isMobile() {
    return $(DOM.window).innerWidth() <= BREAKPOINTS.mobile;
  },
  isTablet() {
    const ww = $(DOM.window).innerWidth();
    return ww > BREAKPOINTS.mobile && ww <= BREAKPOINTS.desktopSm;
  }
};

export const detectTouch = () => {
  if (GLOBAL.isTouch) {
    DOM.$body.addClass('is-touch');
  } else {
    DOM.$body.addClass('is-no-touch');
  }
};

export const updateViewportUnits = () => {
  const vh = window.innerHeight * 0.01;
  DOM.$body.css('--vh', `${vh}px`);
};
